import type { Customer, PaginatedApiResponse } from 'types';
import { baseQuery } from '../baseQuery';

type CustomerQuickSearchParams = { searchValue: string; page?: number; recordsPerPage?: number };

export const getQuickCustomerSearch = async ({ searchValue, page, recordsPerPage }: CustomerQuickSearchParams) => {
  const data: PaginatedApiResponse<Customer[]> = await baseQuery(
    `quick-search-customer?&page=${page || 1}&search_text=${searchValue}&records_per_page=${recordsPerPage || 5}`,
  );

  return data;
};
